module.exports = __webpack_public_path__ + "static/media/MenuIcon.f30a827e.svg";